import React, { createContext, useContext, useState } from 'react';
const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [token, setToken] = useState(null)

    const login = (token) => {
        setIsLoggedIn(true);
        setToken(token);
    };

    const getToken = () => {
        return token;
    }

    return (
        <AuthContext.Provider value={{ isLoggedIn,login, getToken }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () =>{
  return useContext(AuthContext);
}

